/**
 *
 */
export const arrowLeft = {
    paths: [
        {
            d: 'M7.78 12.53a.75.75 0 0 1-1.06 0L2.47 8.28a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L4.81 7h7.44a.75.75 0 0 1 0 1.5H4.81l2.97 2.97a.75.75 0 0 1 0 1.06Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=arrow-left.js.map